import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Landmark, ShoppingCart, Stethoscope, Gamepad2, Building2, Plane, ArrowRight, CheckCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import translations from '../i18n/translations';
import './UseCases.css';

const caseIcons = [
  <Landmark size={28} />,
  <ShoppingCart size={28} />,
  <Stethoscope size={28} />,
  <Gamepad2 size={28} />,
  <Building2 size={28} />,
  <Plane size={28} />,
];

const caseColors = ['#0077ff', '#00d4ff', '#00e676', '#ff6b6b', '#ffd600', '#ab47bc'];

export default function UseCases() {
  const [active, setActive] = useState(0);
  const { lang } = useLang();
  const t = translations[lang].useCases;
  const current = t.cases[active];

  return (
    <div className="use-cases">
      <section className="page-hero">
        <div className="page-hero__orb" />
        <div className="container">
          <span className="section-tag">{t.tag}</span>
          <h1 className="page-hero__title">
            {t.title1} <span className="gradient-text">{t.title2}</span>
          </h1>
          <p className="page-hero__desc">{t.desc}</p>
        </div>
      </section>

      <section className="uc-explorer section">
        <div className="container uc-explorer__inner">
          <div className="uc-sidebar">
            {t.cases.map((c, i) => (
              <button
                key={i}
                className={`uc-sidebar__item ${active === i ? 'uc-sidebar__item--active' : ''}`}
                onClick={() => setActive(i)}
              >
                <span className="uc-sidebar__icon" style={{ color: caseColors[i] }}>{caseIcons[i]}</span>
                <span className="uc-sidebar__label">{c.category}</span>
              </button>
            ))}
          </div>

          <div className="uc-detail" key={`${lang}-${active}`}>
            <div className="uc-detail__icon" style={{ background: `${caseColors[active]}18`, border: `1px solid ${caseColors[active]}40`, color: caseColors[active] }}>
              {caseIcons[active]}
            </div>
            <span className="uc-detail__category" style={{ color: caseColors[active] }}>{current.category}</span>
            <h2 className="uc-detail__title">{current.title}</h2>
            <p className="uc-detail__desc">{current.desc}</p>
            <ul className="uc-detail__benefits">
              {current.benefits.map((b, i) => (
                <li key={i}>
                  <CheckCircle size={15} style={{ color: caseColors[active] }} />
                  {b}
                </li>
              ))}
            </ul>
            <Link to="/contact" className="btn-primary" style={{ marginTop: '2rem', width: 'fit-content' }}>
              {t.getStarted} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-box">
            <div className="cta-box__glow" />
            <h2 className="cta-box__title">{t.ctaTitle}</h2>
            <p className="cta-box__desc">{t.ctaDesc}</p>
            <div className="cta-box__actions">
              <Link to="/contact" className="btn-primary">
                {t.contactSales} <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
